import { Subscribable } from "knockout";
import WCCSliderItem from "../item/base/base.model";

const calcWidth = <I extends WCCSliderItem<any>>(result: number, item: I) => result + item.getWidth();

export default class WCCSliderPage<T, I extends WCCSliderItem<T> = WCCSliderItem<T>> {
    items = ko.observableArray<I>();
    borrowedItems = ko.observableArray<I>();

    width: Subscribable<number>
    borrowedWidth: Subscribable<number>

    allItems: Subscribable<I[]>

    constructor() {
        this.allItems = this.borrowedItems.concat(this.items);

        this.width = this.items.reduce(calcWidth, () => 0);
        this.borrowedWidth = this.borrowedItems.reduce(calcWidth, () => 0);
    }

    contains(item: I) {
        return this.items().includes(item);
    }
}